export enum BlockStatusEnum {
	Designing = 0,
	Designed = 10,
	Programming = 20,
	Programmed = 30,
	Machining = 40,
	Machined = 50,
	Assembling = 60,
	Assembled = 70,
	Done = 80
}
